import React from 'react';
import * as PropTypes from 'prop-types';

import SignConsentButton from '../SingConsentButton';
import { renderConsentHeader } from '../../utils/renderConsentHeader';
import { handleNumberOfCount } from '../../utils/handleNumberOfCount';

import styles from '../index.styl';

export function ConsentDetailsView({
  allConsents,
  buttonAccept,
  consentOutcomeTitles,
  consentTypeName,
  consentVersionTitle,
  convertedTime,
  createMarkup,
  formatMessage,
  handleAcceptConsent,
  id,
  isConsentHasMultipleOutcomes,
  isSignConsentLoading,
  name,
  organizationName,
  providerContext,
  serviceName,
  titleTypeConsent,
  version,
}) {
  return (
    <div className={styles.root}>
      {!providerContext && (
        <div className={styles.header}>
          {renderConsentHeader(
            formatMessage,
            titleTypeConsent,
            organizationName,
            serviceName,
            convertedTime,
            false,
          )}
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <div className={styles.mainTitle}>
            <div className={styles.consentTitle}>{name}</div>
            <div
              className={styles.consentSubTitle}
            >{`${consentTypeName}, ${consentVersionTitle} ${version}`}</div>
          </div>
          <div className={styles.counter}>
            {handleNumberOfCount(allConsents, id)}
          </div>
        </div>
        {/* eslint-disable-next-line react/no-danger */}
        <div className={styles.text} dangerouslySetInnerHTML={createMarkup()} />
        {!providerContext && (
          <SignConsentButton
            buttonAccept={buttonAccept}
            handleAcceptConsent={handleAcceptConsent}
            isConsentHasMultipleOutcomes={isConsentHasMultipleOutcomes}
            isSignConsentLoading={isSignConsentLoading}
            titles={consentOutcomeTitles}
          />
        )}
      </div>
    </div>
  );
}

ConsentDetailsView.propTypes = {
  allConsents: PropTypes.array,
  buttonAccept: PropTypes.string,
  consentOutcomeTitles: PropTypes.arrayOf(PropTypes.string),
  consentTypeName: PropTypes.string,
  consentVersionTitle: PropTypes.string,
  convertedTime: PropTypes.string,
  createMarkup: PropTypes.func,
  formatMessage: PropTypes.func,
  handleAcceptConsent: PropTypes.func,
  id: PropTypes.number,
  isConsentHasMultipleOutcomes: PropTypes.bool,
  isSignConsentLoading: PropTypes.bool,
  name: PropTypes.string,
  organizationName: PropTypes.string,
  providerContext: PropTypes.bool,
  serviceName: PropTypes.string,
  titleTypeConsent: PropTypes.string,
  version: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentDetailsPopup/ConsentDetailsView/index.jsx